import { combineReducers } from 'redux';
import authUser from './auth/authSlice';
import menu from './menu/menuSlice';
import profile from './profile/profileSlice';

const reducers = combineReducers({
    auth: authUser,
    menu,
    profile
});

export default reducers;